import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Building2 } from 'lucide-react';

const PortalSwitch: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = useState(false);

  // На самом портале кнопку не показываем
  if (location.pathname.startsWith('/app/portal')) return null;

  return (
    <button
      onClick={() => navigate('/app/portal')}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title="Корпоративный портал"
      style={{
        position: 'fixed',
        right: 30,
        bottom: 96, // над кнопкой чата (~72px + отступ)
        zIndex: 9998,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: hovered ? 8 : 0,
        height: 56,
        width: hovered ? 150 : 56,
        padding: hovered ? '0 20px 0 14px' : 0,
        borderRadius: 28,
        background: 'linear-gradient(135deg, #ec4899, #db2777)',
        border: '1px solid rgba(255,255,255,0.9)',
        boxShadow: hovered
          ? '0 18px 40px rgba(236,72,153,0.5), 0 6px 16px rgba(236,72,153,0.3), inset 0 1px 0 rgba(255,255,255,0.6)'
          : '0 12px 28px rgba(236,72,153,0.4), inset 0 1px 0 rgba(255,255,255,0.5)',
        color: '#fff',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 14,
        fontWeight: 800,
        letterSpacing: 0.2,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        transition: 'width 0.35s cubic-bezier(0.4, 0, 0.2, 1), padding 0.35s cubic-bezier(0.4, 0, 0.2, 1), gap 0.25s, box-shadow 0.3s, transform 0.25s',
        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
        ...style,
      }}
    >
      <span style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        flexShrink: 0,
        transition: 'transform 0.3s',
        transform: hovered ? 'rotate(-8deg) scale(1.05)' : 'rotate(0deg) scale(1)',
      }}>
        <Building2 size={22} strokeWidth={2.4} />
      </span>
      <span style={{
        opacity: hovered ? 1 : 0,
        maxWidth: hovered ? 120 : 0,
        overflow: 'hidden',
        transition: 'opacity 0.25s ease 0.05s, max-width 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        display: 'inline-block',
      }}>
        Портал
      </span>
    </button>
  );
};

export default PortalSwitch;
